export const required = (value) => {
  return value ? undefined : 'Required';
};

export const futureDate = (value) => {
  return (!value || value > new Date()) ? undefined : 'Date must be in the future';
};
